
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SecurityOverrideGrid extends SiteEntityGrid<SecurityOverrideRow, any> {
        protected getColumnsKey() { return 'Rebalancer.SecurityOverride'; }
        protected getDialogType() { return SecurityOverrideDialog; }
        protected getIdProperty() { return SecurityOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityOverrideRow.localTextPrefix; }
        protected getService() { return SecurityOverrideService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}